// @react/hooks/useApikey.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { apikeyStore } from '@core/stores';

/**
 * React hook for APIKey operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useApikey } from '@react/hooks';
 *
 * const APIKeyList = observer(() => {
 *   const store = useApikey();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useApikey() {
  return apikeyStore;
}
